var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector3Red(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 48,
    viewBox: "0 0 50 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3183 3.86002L10.8624 0.404187C5.06243 4.82669 1.2441 11.6417 0.905762 19.375H5.7391C5.91028 16.3102 6.77059 13.3235 8.25598 10.6373C9.74136 7.95105 11.8135 5.63447 14.3183 3.86002ZM44.2608 19.375H49.0941C48.7316 11.6417 44.9133 4.82669 39.1374 0.404187L35.7058 3.86002C38.1998 5.6432 40.2627 7.96234 41.7431 10.6471C43.2235 13.3319 44.0838 16.3142 44.2608 19.375ZM39.4999 20.5834C39.4999 13.1642 35.5366 6.95335 28.6249 5.31002V0.041687H21.3749V5.31002C14.4391 6.95335 10.4999 13.14 10.4999 20.5834V32.6667L5.66659 37.5V39.9167H44.3333V37.5L39.4999 32.6667V20.5834ZM24.9999 47.1667C25.3383 47.1667 25.6524 47.1425 25.9666 47.07C27.5374 46.7317 28.8183 45.6684 29.4466 44.2184C29.6883 43.6384 29.8091 43.01 29.8091 42.3334H20.1424C20.1666 44.9917 22.3174 47.1667 24.9999 47.1667Z",
    fill: "#F05A28"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector3Red);
export default __webpack_public_path__ + "static/media/vector-3-red.2454e6f3304ab84c39dfddd2fa9f7e2f.svg";
export { ForwardRef as ReactComponent };